import React from 'react';
import {connect} from 'react-redux';

import { EmployeeSelector } from '/app/src/model/selectors'
import { PaymentSelector, CompanySelector } from '/app/src/model'
import {Flex} from '/app/src/component';

import PlanPage from './Pages/PlanPage'
import PaymentInfoPage from './Pages/PaymentInfoPage'
import OverviewPage from './Pages/OverviewPage'

/*This modal is almost fully self-contained in terms of
* 1. Not needing many props to function (check mapStateToProps and props)
* 2. Handles all request on its own.
* However, it needs adjustment if price plans were to change.
*/
class PaymentModal extends React.Component {
    constructor(props) {
        super(props)
        this.handleButtonClick = this.handleButtonClick.bind(this)
        this.onBackClick = this.onBackClick.bind(this)
        this.onNextClick = this.onNextClick.bind(this)
        this.handleOnChange = this.handleOnChange.bind(this)
        this.translatePlan = this.translatePlan.bind(this)
        this.calculateTotal = this.calculateTotal.bind(this)

        this.state = {
            step: 0,

            //Contract
            plan: "start",
            subscription: "monthly",

            //PaymentInfo
            companyName: "",
            email: "",
            orgNbr: "",
            country: "Sverige",
            address: "",
            city: "",
            postalCode: "",

            //Overview
            period: "monthly"
        }
    }

    componentDidMount() {


        //Default values if server returns 404.
        this.setState({
            plan: this.props.currentPlan === "standard" ? "start" : this.props.currentPlan, //Standard is associated with start if company wants to upgrade
            subscription: this.props.currentSubscription,
            companyName: this.props.companyName || "",
            email: this.props.email || "",
            orgNbr: this.props.orgNumber || "",
            country: 'Sverige' || "",
            address: this.props.address || "",
            city: this.props.city || "",
            postalCode: this.props.postalCode || "",
            period: this.props.currentPeriod || "monthly"
        })
    }

    translatePlan(str) {
        const TRANSLATION = {
            'monthly': 'Månadsvis',
            'yearly': 'Årsvis',
            'start': 'Start',
            'pro': 'PRO',
            'quarterly': 'Kvartalsvis',
        }
        if (str in TRANSLATION) return TRANSLATION[str]
        else return str
    }

    calculateTotal(plan, subscription) {
        const {plans, nbrEmployees} = this.props
        const monthlyCost = nbrEmployees * plans.getIn([plan, 'monthly', 'cost_per_user'])
        if (subscription === 'yearly') {
            const yearlyCost = nbrEmployees * plans.getIn([plan, 'yearly', 'cost_per_user'])
            return yearlyCost
        }
        return monthlyCost
    }

    handleButtonClick(btnName) {
        switch(btnName) {
            case 'monthlyBtn':
                this.setState({subscription: 'monthly'})
                break
            case 'yearlyBtn':
                this.setState({subscription: 'yearly'})
                break
            case 'proBtn':
                this.setState({plan: 'pro'})
                break
            case 'startBtn':
                this.setState({plan: 'start'})
                break
            case 'monthlyPeriodBtn':
                this.setState({period: 'monthly'})
                break
            case 'quarterlyPeriodBtn':
                this.setState({period: 'quarterly'})
                break
            default:
        }
    }

    handleOnChange(name, value) {
        this.setState({[name]: value})
    }

    onNextClick(step) {
        switch(step) {
            case 0:
                this.setState((prevState) => ({step: prevState.step+1}))
                break
            case 1:
                this.setState((prevState) => ({step: prevState.step+1}))
                break
            case 2:
                this.props.onFinish(this.state)
                break
            default:
                break
        }
    }

    onBackClick(step) {
        switch(step) {
            case 0:
                this.props.onClose()
                break
            case 1:
                this.setState((prevState) => ({step: prevState.step-1}))
                break
            case 2:
            default:
                this.setState((prevState) => ({step: prevState.step-1}))
                break
        }
    }

    render() {
        const {step, subscription, plan, companyName, email, orgNbr, country,
            address, city, postalCode } = this.state
        const { currentSubscription, isBlockScreen, nbrEmployees } = this.props

        switch(step) {
            case 0:
                return (
                    <PlanPage
                        {...{subscription, plan, currentSubscription, nbrEmployees}}
                        handleButtonClick={this.handleButtonClick}
                        backButtonClick={isBlockScreen ? null : () => this.onBackClick(0) }
                        nextButtonClick={() => this.onNextClick(0)}
                        calculateTotal={this.calculateTotal}
                        translatePlan={this.translatePlan}/>
                    )
            case 1:
                return (
                    <PaymentInfoPage
                        handleButtonClick={this.handleButtonClick}
                        backButtonClick={() => this.onBackClick(1)}
                        nextButtonClick={() => this.onNextClick(1)}
                        onChange={this.handleOnChange}
                        {...{companyName,
                            email,
                            orgNbr,
                            country,
                            address,
                            city,
                            postalCode,
                        }}/>
                    )
            case 2:
                return (
                    <OverviewPage
                        handleButtonClick={this.handleButtonClick}
                        backButtonClick={() => this.onBackClick(2)}
                        nextButtonClick={() => this.onNextClick(2)}
                        {...this.props}
                        {...this.state}
                        calculateTotal={this.calculateTotal}
                        translatePlan={this.translatePlan}/>
                    )
            default:
                return <Flex> </Flex>
        }
    }
}

function mapStateToProps(state, props) {
    const nbrEmployees = EmployeeSelector.getAll(state).size
    const plans = PaymentSelector.getPaymentPlans(state, ['start', 'pro'])
    const companyInfo = CompanySelector.getCompanyBillingInfo(state)
    const currentPlan = CompanySelector.getPaymentPlan(state)
    const currentPeriod = CompanySelector.getPaymentPeriod(state)
    const currentSubscription = CompanySelector.getCurrentSub(state)

    return {
        currentSubscription,
        nbrEmployees,
        plans,
        currentPlan,
        currentPeriod,
        isPrivate: companyInfo.get('private_person'),
        companyName: companyInfo.get('name'),
        address: companyInfo.get('address'),
        email: companyInfo.get('email'),
        city: companyInfo.get('city'),
        orgNumber: companyInfo.get('org_nbr'),
        postalCode: companyInfo.get('postal_code'),
        referenceName: companyInfo.get('ref_name'),
        referenceEmail: companyInfo.get('ref_email'),
    }
}

export default connect(mapStateToProps, null)(PaymentModal);



// WEBPACK FOOTER //
// ./src/component/Modal/PaymentModal/PaymentModal.js